/**
 * Utilitaires pour l'affichage dynamique de la contenance colis
 * selon l'unité du produit.
 */

/** Label du champ dans le formulaire admin */
export function getPackageLabel(unit) {
  switch (unit) {
    case 'kg': return 'Poids / colis (kg)';
    case 'pièce': return 'Nbr de pièces / colis';
    case 'barquette': return 'Nbr de barquettes / colis';
    case 'bouquet': return 'Nbr de bouquets / colis';
    case 'sachet': return 'Nbr de sachets / colis';
    case 'pack': return 'Nbr de packs / colis';
    case 'litre': return 'Volume / colis (L)';
    default: return 'Contenance / colis';
  }
}

/** Description sous le champ dans le formulaire admin */
export function getPackageDescription(unit) {
  switch (unit) {
    case 'kg': return 'Poids en kg du colis. Total = prix/kg x poids x quantité';
    case 'pièce': return 'Nombre de pièces par colis. Total = prix/pièce x nbr pièces x quantité';
    case 'barquette': return 'Nombre de barquettes par colis. Total = prix/barquette x nbr x quantité';
    default: return 'Contenance du colis. Total = prix unitaire x contenance x quantité';
  }
}

/** Step du champ numérique (0.1 pour kg/litre, 1 pour le reste) */
export function getPackageStep(unit) {
  return (unit === 'kg' || unit === 'litre') ? '0.1' : '1';
}

/** Affichage court : "5 kg" ou "30 pièces" */
export function getPackageDisplay(weight, unit) {
  if (unit === 'pièce') return `${weight} pièces`;
  return `${weight} ${unit}`;
}

/** Suffixe prix : "/kg", "/pièce", "/barquette" */
export function getPricePerUnit(unit) {
  return `/${unit}`;
}
